export {
  default as indoor,
  ReactComponent as Indoor,
} from '@assets/icons/features-and-amenities/indoor.svg'    
